'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _Pagination = _interopRequireDefault(require("Components/Pagination"));
var _Checked = _interopRequireDefault(require("Icons/Checked"));
var _Sort = _interopRequireDefault(require("Icons/Sort"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class Dashboard extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      loading: true,
      data: [],
      data_count: 0,
      page: 0,
      rows_per_page: this.props['items-per-page'] || 10,
      order: this.props.order || 'desc',
      order_by: this.props['order-by'] || 'created_at',
      searched: '',
      status_messages: {},
      selected: {}
    });
    (0, _defineProperty2.default)(this, "fetchData", _ref => {
      let {
        page,
        order,
        order_by
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;
      const current_page = typeof page === 'undefined' ? state.page : page;
      let update = {};
      [page, order, order_by].filter(prop => typeof prop !== 'undefined').forEach(prop => update[prop] = prop);
      component.setState(_objectSpread(_objectSpread({}, update), {}, {
        loading: true,
        selected: {}
      }));
      qwest.post(props.url, _objectSpread(_objectSpread({
        limit: state.rows_per_page,
        skip: state.rows_per_page * current_page,
        with_count: true
      }, props.filters || {}), {}, {
        order: order || state.order,
        order_by: order_by || state.order_by
      })).then(function (xhr, response) {
        if (order) component.setState({
          order: order
        });
        if (order_by) component.setState({
          order_by: order_by
        });
        if (typeof props.onSelection === 'function') {
          props.onSelection();
        }
        component.setState({
          loading: false,
          data_count: response.count || 0,
          data: response.data || []
        });
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
    (0, _defineProperty2.default)(this, "handlePageChange", (e, page) => {
      const component = this,
        props = this.props,
        state = this.state;
      if (state.loading === true) return;
      component.setState({
        page: page
      });
      component.fetchData({
        page: page
      });
    });
    (0, _defineProperty2.default)(this, "toggleSelection", (e, data) => {
      const component = this,
        props = this.props,
        state = this.state;
      state.selected[data.id] = !state.selected[data.id];
      component.setState({
        selected: state.selected
      });
      props.onSelection(e, data);
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchData({});
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    const prev_filters = prev_props.filters || {};
    const changes = Object.keys(props.filters || {}).some(function (field) {
      if (!props.filters[field] && !prev_filters[field]) return false;
      return props.filters[field] !== prev_filters[field];
    });
    if (changes) component.fetchData({
      page: 0
    });
  }
  sort(e, field) {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    const order_by = field;
    let order = 'desc';
    if (state.order_by === order_by && state.order === 'desc') {
      order = 'asc';
    }
    component.fetchData({
      order: order,
      order_by: order_by
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const Row = props.component || undefined;
    let data = [];
    if (Row) {
      data = state.data.map(function (data) {
        const selection = props.onSelection ? /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: "c-dashboard__cell selection",
          onClick: e => component.toggleSelection(e, data)
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "u-readers-only"
        }, "Cocher"), state.selected[data.id] ? /*#__PURE__*/_react.default.createElement(_Checked.default, {
          className: "c-dashboard__selected"
        }) : undefined) : undefined;
        const output = /*#__PURE__*/_react.default.createElement(Row, {
          data: data,
          key: data.id,
          blank: props.blank,
          fields: props.fields
        }, selection);
        return output;
      });
    } else if (typeof props.render === 'function') {
      data = state.data.map(data => props.render(data));
    } else {
      return null;
    }
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const header = (props.header || []).map(function (field) {
      let classes = 'c-dashboard__cell';
      if (field.sortable !== false) classes += ' ' + 'sortable';
      classes += ' ' + props.model + '-' + field.name.split('.').join('_');
      let sort_class = 'c-dashboard__sort';
      if (field.align && field.align !== 'left') {
        classes += ' u-content-' + field.align;
      }
      if (state.order_by === field.name) {
        classes += ' ' + state.order;
      }
      const sort_indicator = state.order_by === field.name ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Sort.default, {
        className: "c-dashboard__sort-icon"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-dashboard__sort-arrow"
      })) : undefined;
      const sort_btn = field.sortable !== false ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: sort_class,
        onClick: e => component.sort(e, field.name)
      }, field.label, sort_indicator) : field.label;
      let output = /*#__PURE__*/_react.default.createElement("div", {
        key: field.name,
        className: classes
      }, sort_btn);
      return output;
    });
    const model_name = props.model.toLowerCase();
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _bemit.default)('c-dashboard', ['head', model_name])
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-dashboard__row"
    }, props.onSelection ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-dashboard__cell selection"
    }) : undefined, header)), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _bemit.default)('c-dashboard', [model_name])
    }, data)), props.pagination !== false ? /*#__PURE__*/_react.default.createElement(_Pagination.default, {
      current: state.page,
      total: state.data_count,
      "items-per-page": state.rows_per_page,
      onChange: component.handlePageChange
    }) : undefined, loader);
    return output;
  }
}
exports.default = Dashboard;
